import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SearchCriteria } from '../models/searchCriteria';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  allDepos = [];
  userRoles = [];

  private searchCriteria = new BehaviorSubject<SearchCriteria>(null);
  searchCriteriaObserable = this.searchCriteria.asObservable();
  constructor() { }

  setSearchCriteria(value) {
    this.searchCriteria.next(value);
  }
}
